import React from 'react'

import Navigation from './components/navigation'
import Footer from './components/footer'

import './scss/style.scss'

const License = () => (
  <>
    <header className="pt-120 bg-light header_1">
      <Navigation />
    </header>

    <section className="pt-105 pb-95 bg-light content_2">
      <div className="container px-xl-0 text-center">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <h2>License</h2>
          </div>
          <div className="col-xl-7 col-lg-9 col-md-10">
            <div className="mt-35 f-18 medium color-heading op-7 text-adaptive">
              <div>
              LAST UPDATED: MARCH 9, 2020
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="pt-10 pb-100 bg-light content_11">
      <div className="container px-xl-0" />
      <div className="container mr-70 px-xl-0">
        <p>Use our themes and templates for multiple projects, both personal and commercial - link is required.</p>
        <p>But there are some things you can't do:</p>

        <ul>
          <li>Redistribute or resell our themes and templates or source files.</li>
          <li>Offer themes and templates to users of your hosting or blogging service.</li>
          <li>Create templates, themes and plugins for sale or free distribution.</li>
        </ul>
      </div>
    </section>

    <Footer />
  </>
)

export default License
